<script>
    import TabHeading from './TabHeading.svelte';
    import {createEventDispatcher} from 'svelte/internal';

    export let titles = [];
    export let activeTab = 1;
    export let cssClass = '';

    let tabs = [];
    let index = 1;

    const dispatch = createEventDispatcher();

    const onSwitchTab = ({detail}) => {
        tabs.map(item => {
            item.active = false;
        });
        activeTab = detail.index;
        tabs = tabs;
        dispatch('click', detail);
    }

    titles.map(title => {
        let tab = {
            index: index,
            title: title,
            active: index === activeTab,
        }
        tabs.push(tab);
        index++;
    });
</script>

<div class="tab-nav {cssClass}">
    <ul class="tabs">
        {#each tabs as tab}
            <TabHeading tab="{ tab }" on:switch_tab="{ onSwitchTab }"/>
        {/each}
    </ul>

    <div class="content">
        {#if tabs.length > 0}
            <div class="tab-content" class:visible="{ activeTab === 1 }">
                <slot name="tab1"/>
            </div>
        {/if}
        {#if tabs.length > 1}
            <div class="tab-content" class:visible="{ activeTab === 2 }">
                <slot name="tab2"/>
            </div>
        {/if}
        {#if tabs.length > 2}
            <div class="tab-content" class:visible="{ activeTab === 3 }">
                <slot name="tab3"/>
            </div>
        {/if}
        {#if tabs.length > 3}
            <div class="tab-content" class:visible="{ activeTab === 4 }">
                <slot name="tab4"/>
            </div>
        {/if}
        {#if tabs.length > 4}
            <div class="tab-content" class:visible="{ activeTab === 5 }">
                <slot name="tab5"/>
            </div>
        {/if}
        {#if tabs.length > 5}
            <div class="tab-content" class:visible="{ activeTab === 6 }">
                <slot name="tab6"/>
            </div>
        {/if}
        {#if tabs.length > 6}
            <div class="tab-content" class:visible="{ activeTab === 7 }">
                <slot name="tab7"/>
            </div>
        {/if}

        <slot name="footer"/>
    </div>
</div>

<style>
    .tab-nav {
        border-bottom: 1px solid #eff2f7;
    }

    .tab-nav:after {
        content: "";
        clear: both;
        display: table;
    }

    .tab-nav ul.tabs {
        list-style: none;
        border-bottom: 1px solid #dfdfdf;
        padding: 0;
        margin: 0 2px 0 2px;
    }

    .tab-nav ul.tabs:after {
        content: "";
        clear: both;
        display: table;
    }

    .tab-nav .content .tab-content {
        display: none
    }

    .tab-nav .content .tab-content.visible {
        display: block;
    }

    .content {
        background: #fff;
        border: var(--default-border);
        border-radius: 3px;
        padding: 20px;
        margin-top: -1px;
    }
</style>